import { apiRequest } from "./api";

export async function getReportIssuePrioritiesByPriority(priority: string) {
  if (priority) {
    const response = await apiRequest<ReadReportIssuePrioritiesDto>(
      "get",
      `/reportIssuePriorities/find-by-priority?priority=${priority}`
    );
    return response;
  }
}

export async function getReportIssuePrioritiesByUuid(uuid: string) {
  if (uuid) {
    const response = await apiRequest<ReadReportIssuePrioritiesDto>(
      "get",
      `/reportIssuePriorities/find-by-uuid?uuid=${uuid}`
    );
    return response;
  }
}

export async function selectreportIssuePriorities() {
  const response = await apiRequest<SelectReportIssuePrioritiesDto[]>(
    "get",
    `/reportIssuePriorities/select`
  );
  return response;
}

export async function selectreportIssuePrioritiesByCompanyUuid(
  companyUuid: string
) {
  const response = await apiRequest<SelectReportIssuePrioritiesDto[]>(
    "get",
    `/reportIssuePriorities/select-companyUuid?companyUuid=${companyUuid}`
  );
  return response;
}

export async function getreportIssuePrioritiesListAndSearch(
  page: number,
  itemsPerPage: number,
  search?: string
): Promise<ListReportIssuePrioritiesDto> {
  let query = "?";
  query += page ? `page=${page}&` : "";
  query += itemsPerPage ? `itemsPerPage=${itemsPerPage}&` : "";
  query += search ? `search=${search}` : "";

  return await apiRequest<ListReportIssuePrioritiesDto>(
    "get",
    `/reportIssuePriorities/list${query}`
  );
}

export async function updateReportIssuePriorities(
  uuid: string,
  data: UpdateReportIssuePrioritiesDto
) {
  if (uuid) {
    const response = await apiRequest<ReadReportIssuePrioritiesDto>(
      "put",
      `/reportIssuePriorities/update?uuid=${uuid}`,
      data
    );
    return response;
  }
}

export async function updateReportIssuePrioritiesByCompanyUuid(
  uuid: string,
  companyUuid: string,
  data: UpdateReportIssuePrioritiesDto
) {
  if (uuid) {
    const response = await apiRequest<ReadReportIssuePrioritiesDto>(
      "put",
      `/reportIssuePriorities/update-by-companyUuid?uuid=${uuid}&companyUuid=${companyUuid}`,
      data
    );
    return response;
  }
}

export async function deleteReportIssuePriorities(uuid: string) {
  if (uuid) {
    const response = await apiRequest<DeleteDto>(
      "delete",
      `/reportIssuePriorities/soft-delete?uuid=${uuid}`
    );
    return response;
  }
}
